import { Trophy, Sparkles, Heart, Globe, Award, Flag } from "lucide-react";

const t = {
  fr: {
    title: "Avantages Concurrentiels",
    subtitle: "Pourquoi EcoLunch Gagne",
    cards: [
      { icon: Sparkles, title: "UX Moderne", sub: "vs. plateformes coincées dans l'UI 2014–2016", desc: "EcoLunch offre une expérience propre, moderne et intuitive" },
      { icon: Trophy, title: "Plateforme Standardisée", sub: "vs. sites personnalisés cloisonnés", desc: "Un système → qualité cohérente" },
      { icon: Heart, title: "Continuité Axée sur les Parents", sub: "vs. recommencer chaque année", desc: "Les parents font confiance à EcoLunch, pas au fournisseur" },
      { icon: Globe, title: "Conçu pour le Québec et le Canada", sub: "vs. concurrents centrés sur les États-Unis", desc: "Règles fiscales, support bilingue, logique du système scolaire local" },
      { icon: Award, title: "Forte Présence de Marque", sub: "Visible partout", desc: "EcoLunch devient un nom familier pour la commande de repas scolaires" },
      { icon: Flag, title: "100 % Québécois", sub: "vs. solutions hors province ou hors pays", desc: ["Entreprise Québécoise", "Centre de données OVHcloud MTL", "Processeur de paiements PaySafe MTL", "BNPL Sezzle Canada", "Conçu, pensé et adapté au système scolaire de chez nous"] },
    ],
  },
  en: {
    title: "Competitive Advantages",
    subtitle: "Why EcoLunch Wins",
    cards: [
      { icon: Sparkles, title: "Modern UX", sub: "vs. platforms stuck in 2014–2016 UI", desc: "EcoLunch offers a clean, modern and intuitive experience" },
      { icon: Trophy, title: "Standardized Platform", sub: "vs. siloed custom sites", desc: "One system → consistent quality" },
      { icon: Heart, title: "Parent-Focused Continuity", sub: "vs. starting over each year", desc: "Parents trust EcoLunch, not the supplier" },
      { icon: Globe, title: "Built for Quebec and Canada", sub: "vs. US-centric competitors", desc: "Tax rules, bilingual support, local school system logic" },
      { icon: Award, title: "Strong Brand Presence", sub: "Visible everywhere", desc: "EcoLunch becomes a household name for school meal ordering" },
      { icon: Flag, title: "100% Quebecois", sub: "vs. out-of-province or foreign solutions", desc: ["Quebec-based company", "OVHcloud MTL data center", "PaySafe MTL payment processor", "Sezzle Canada BNPL", "Built and designed for the local school system"] },
    ],
  },
};

export default function CompetitiveSection({ lang }) {
  const c = t[lang];
  return (
    <section data-testid="competitive-section" className="py-16 sm:py-24 bg-darker">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-primary/20 mb-6 glow-strong">
            <Trophy className="h-8 w-8 sm:h-10 sm:w-10 text-primary" />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">{c.title}</h2>
          <p className="text-xl text-gradient-lime font-bold">{c.subtitle}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {c.cards.map((card) => {
            const Icon = card.icon;
            return (
              <div key={card.title} className="rounded-xl border text-card-foreground shadow hover-lift bg-dark border-primary/30 hover:border-primary transition-all duration-300">
                <div className="p-6 pt-6 sm:pt-8 pb-6 sm:pb-8">
                  <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-primary/20 mb-4 sm:mb-6 glow-primary">
                    <Icon className="h-6 w-6 sm:h-7 sm:w-7 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{card.title}</h3>
                  <p className="text-sm text-white/60 mb-4">{card.sub}</p>
                  {Array.isArray(card.desc) ? (
                    <ul className="space-y-2">
                      {card.desc.map((item) => (
                        <li key={item} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-1.5 glow-primary" />
                          <span className="text-sm font-semibold text-white">{item}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-sm font-semibold text-white">{card.desc}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
